import React from "react"
import "./product-details.css"

export default function NutritionalInfo({ nutritionalFacts }) {
  return (
    <div className="product_details_nutrition_table_container">
      <table className="product_details_nutrition_table">
        <thead className="product_details_nutrition_header">
          <tr>
            <th className="product_details_nutrition_header_cell" colSpan={3}>
              Nutrition Facts (per 100g)
            </th>
            <th className="product_details_nutrition_header_cell" colSpan={3}>
              Daily Value %
            </th>
          </tr>
        </thead>
        <tbody className="product_details_nutrition_body">
          <tr className="product_details_nutrition_row product_details_nutrition_row_main">
            <td className="product_details_nutrition_cell">Energy</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.energy.value} kcal</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.energy.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell">Total Fat</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.totalFat.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.totalFat.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell product_details_nutrition_cell_indent">Saturated Fat</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.saturatedFat.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.saturatedFat.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell product_details_nutrition_cell_indent">Trans Fat</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.transFat.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.transFat.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell">Cholesterol</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.cholesterol.value}mg</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.cholesterol.dailyValue || "0"}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell">Sodium</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.sodium.value}mg</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.sodium.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell">Total Carbohydrate</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.totalCarbohydrate.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.totalCarbohydrate.dailyValue || "0"}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell product_details_nutrition_cell_indent">Dietary Fiber</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.dietaryFiber.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.dietaryFiber.dailyValue || "0"}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell product_details_nutrition_cell_indent">Total Sugars</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.totalSugars.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.totalSugars.dailyValue || "0"}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell product_details_nutrition_cell_indent">Added Sugars</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.addedSugars.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.addedSugars.dailyValue}%
            </td>
          </tr>
          <tr className="product_details_nutrition_row">
            <td className="product_details_nutrition_cell">Protein</td>
            <td className="product_details_nutrition_cell">{nutritionalFacts.protein.value}g</td>
            <td className="product_details_nutrition_cell product_details_nutrition_cell_right">
              {nutritionalFacts.protein.dailyValue || "0"}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
